export const sideScroll = (element: HTMLElement, options: Record<string, string | number>) => {
  const step = options.step as number;
  const distance = options.distance as number;
  const direction = options.direction as string;

  element.style.scrollBehavior = 'smooth';

  if (direction === 'left') {
    element.scrollLeft -= distance;
  } else {
    element.scrollLeft += distance;
  }

  // Optionally reset scroll-behavior if needed later
  setTimeout(() => {
    element.style.scrollBehavior = '';
  }, 500); // enough time for animation to complete
};
